import { createContext } from "react";
import { ExpertsService } from "../../../../services/expert/experts/index";

export const ExpertServiceContext = createContext({
  ExpertsService: new ExpertsService()
});
